module.exports = __webpack_public_path__ + "img/CNA.d9abcb11.svg";